'use client';

import { useFormState } from 'informed';
import { useEffect } from 'react';

import {
  PersistentFormName,
  usePersistentFormsSlice,
} from '@/store/commonStore/slices/persistant/usePersistentFormsSlice';

const sensitiveFields = ['password'];

export function usePersistentForm(formName: PersistentFormName) {
  const { setPersistentFormField: setFormField } = usePersistentFormsSlice();
  const { values } = useFormState();
  const valuesString = JSON.stringify(Object.values(values || {}));

  useEffect(() => {
    if (valuesString) {
      Object.entries(values || {}).forEach(([field, value]) => {
        if (!sensitiveFields.includes(field)) {
          setFormField(formName, field, value);
        }
      });
    }
  }, [valuesString, formName]);
}
